import React from "react"
import Layout from "hoc/Layout"
import Hr from "components/Hr/Hr"
import Font42 from "components/Fonts/Font42"
import Header from "containers/Contact/Header"
import FormSection from "containers/Homepage/FormSection/FormSection"

const Contact = () => {
  const breadcrumbsData = [
    {
      title: "Startseite",
      link: "/",
    },
    "Kontakt",
  ]
  return (
    <Layout breadcrumbsData={breadcrumbsData} seoTitle="Kontakt">
      <Header />
      <Hr mb={4} mt={6} />
      <Font42 mb={4}>Kontakt</Font42>
      <FormSection />
    </Layout>
  )
}

export default Contact
